<template>
  <div style="height: 100%">
    <!-- <hear></hear> -->
    <div>
      <div class="Guarantee_status_box ">
        <div
          style="
         
            display: flex;
            justify-content: space-between;
          
          "
        >
          <div style="display: flex">
            <el-button
              @click="shuaxin"
              type="info"
              icon="el-icon-refresh-right"
              class="anniu"
            ></el-button>
            <!-- <el-button
                class="anniu"
                type="success"
                icon="el-icon-plus"
                @click="handleAdd"
                >添加</el-button> -->
          </div>

          <div style="display: flex; justify-content: space-around">
            <el-row
              style="display: flex;
    justify-content:  flex-end;"
              class="mb8"
            >
              <el-col :span="19" class="seach">
                <el-input
                  v-model="params.keywords"
                  placeholder="请输入"
                ></el-input>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="shuaxin"
                ></el-button>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="shenflex puhu">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            class="table xtable"
            stripe
            border
            align="center"
            v-loading="loading"
            highlight-current-row
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              prop="proid"
              align="center"
              label="序号"
              @click="details"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="bidding_number"
              :show-overflow-tooltip="true"
              width="220"
              align="center"
              label="项目编号"
            ></el-table-column>
            <el-table-column
              prop="bidding_project_number"
              align="center"
              label="包号"
              :show-overflow-tooltip="true"
              width="220"
            ></el-table-column>
            <el-table-column
              prop="bidding_project_name"
              align="center"
              label="项目名称"
              :show-overflow-tooltip="true"
              width="380"
            ></el-table-column>
            <el-table-column
              prop="bidding_type"
              align="center"
              label="采购方式"
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column align="center" width="160" label="开标日期">
              <template slot-scope="scope">
                <span v-show="scope.row.bid_begin_time == null">暂无</span>
                <span v-show="scope.row.bid_begin_time != null">{{
                  scope.row.bid_begin_time | dateFormat
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="160" label="截止日期">
              <template slot-scope="scope">
                <span v-show="scope.row.bid_end_time == null">暂无</span>
                <span v-show="scope.row.bid_end_time != null">{{
                  scope.row.bid_end_time | dateFormat
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              align="center"
              label="采购需求内容"
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="margin_amount"
              align="center"
              label="预算金额"
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="source"
              align="center"
              label="信息来源"
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column align="center" label="资金来源">
              <template slot-scope="scope">
                {{
                  scope.row.moneysource == 0
                    ? "政府资金"
                    : scope.row.moneysource == 1
                    ? "自筹资金"
                    : "其他自己资金"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="scope"
              :show-overflow-tooltip="true"
              width="120"
              fixed="right"
              align="center"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="chakan(scope.row)" size="small"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-dialog
        title="添加步骤"
        :visible.sync="opens"
        width="700px"
        append-to-body
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <div style="display: flex; justify-content: center; margin-top: 20px">
            <div>
              <el-form-item label="操作名称">
                <el-input v-model="form.operation"></el-input>
              </el-form-item>
              <el-form-item label="审核等级">
                <el-input v-model="form.dengji"></el-input>
              </el-form-item>
            </div>
          </div>
          <div style="display: flex; justify-content: center">
            <!-- <el-button @click="buzhoulis" type="primary">确定</el-button> -->
            <el-button style="margin: 0px" type="primary">确定</el-button>
            <!-- <el-button @click="cancels">取消</el-button> -->
          </div>
        </el-form>
      </el-dialog>
      <el-dialog
        title="添加流程"
        :visible.sync="open"
        width="400px"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="流程名称">
            <el-input v-model="liuch.lc_name"></el-input>
          </el-form-item>
          <div
            style="display: flex; justify-content: center; margin-top: 20px"
          ></div>
        </el-form>
      </el-dialog>
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentpage"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="limit"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { zhaobiao } from "@/api/system/liucheng";
// import hear from ".././../components/hear.vue";
import axios from "axios";
export default {
  components: {
    // hear
  },
  name: "progress",
  data() {
    return {
      total: null,
      currentpage: null,
      // params: {
      //   limit: 4,
      //   offset: 0,
      //   keywords: "",
      //   // user_id: sessionStorage.getItem("user_id"),
      // },
      BidingDocumentList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      opens: false,
      params: {
        page: 0,
        page_limit: 10,
        keywords: ""
        // user_id: sessionStorage.getItem("id"),
      },
      total: null,
      limit: null,
      // 表单参数
      form: {
        name1: "",
        name2: "",
        name3: "",
        dept: "",
        user_id: "",
        lc_id: "",
        bm_id: "",
        bm_name: "",
        staff_id: "",
        staff_name: "",
        operation: "",
        dengji: ""
      },
      loading:true,
      // 表单校验
      rules: {},
      options1: [], //选择部门
      options2: [], //选择职位
      btype: [],
      options3: [], //选择小组
      options4: [], //选择小组
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      tableData: [],
      multipleSelection: [],
      liuch: {
        user_id: sessionStorage.getItem("id"),
        lc_name: "",
        gtype: ""
      },
      buzhl: false,
      buzhilist: []
    };
  },
  mounted() {
    // this.getBhlist();
    this.zhifu();
  },
  methods: {
    sousuo() {},
    handleUpdate(e) {
      // this.reset();
      this.opens = true;
      //   this.title = "修改员工信息";
    },

    buzhlist(e) {
      this.buzhl = true;
    },
    details() {},
    chakan(e) {
      console.log(e);
      this.$router.push({ name: "details", query: e });
    },
    zhifu() {
      var bbc = this.params;
      zhaobiao(bbc).then(res => {
        console.log("中标列表", res.data.data);
        if (res.data.code == 1) {
          this.loading=false
          this.limit = res.data.data.weikai_total;
          this.tableData = res.data.data.weikai;
        } else {
          console.log("失败", err.response.data);
          this.$notify.error({
            message: err.response.data.msg
          });
        }
      });
    },
    shuaxin() {
      this.zhifu();
      this.loading=true
    },
    getBhlist() {
      bhlist(this.params).then(res => {
        this.BidingDocumentList = res.data.data.rows;
        this.total = res.data.data.total;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.page_limit = val;
      this.zhifu();
    },
    handleCurrentChange(val) {
      this.params.page = parseInt(val - 1) * this.params.limit;
      this.currentpage = val;
      this.this.zhifu();
    }
  }
};
</script>

<style scoped>
html body {
  height: 100% !important;
  /* background-color: #f5f6fa !important; */
}
.block {
  padding: 10px;
  /* padding-top: 5px !important; */
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.state_bh {
  font-size: 18px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #1890ff;
  width: 143px;
  height: 47px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  line-height: 47px;
  text-align: center;
  border: 2px solid #1890ff;
}
.shenflex {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 20px; */
  padding-top: 0px;
  padding-top: 10px;
}
.status_bg1 {
  width: 85px;
  height: 40px;
  background-color: #ff1818;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.status_bg {
  width: 85px;
  height: 40px;
  background-color: #1795ff;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.examine_btn {
  width: 143px;
  height: 47px;
  color: #1795ff;
}

.bubble {
  color: #ffffff;
  font-size: 12px;
  width: 94px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 31px;
  margin-left: 20px;
  background-image: url("../../assets/Guarantee/Bubble.png");
}

.Guarantee_details {
  justify-content: space-around;
}

.Ge_box {
  width: 113px;
  height: 33px;
  border-radius: 4px;
  background-color: #1795ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin-left: 15px;
}

.Guarantee_num {
  width: 219px;
  height: 48px;
  color: #333333;
}

.Guarantee_status_box {
  /* position: relative;
  top: 9%;
  left: 247px; */
}

.Guarantee_status {
  width: 95%;
  height: 162px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
}

.Guarantee_examine {
  color: #333333;
  font-size: 24px;
  margin-left: 30px;
  margin-top: 10px;
  font-weight: Bold;
  margin-bottom: 36px;
}

::v-deep .el-table__body-wrapper {
  height: 69vh !important;
  /* margin-top: 10px; */
  overflow: auto !important;
}
</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/view/biao/zhao.vue